import { render, staticRenderFns } from "./block_voucher.vue?vue&type=template&id=1d427ec4&"
import script from "./block_voucher.vue?vue&type=script&lang=js&"
export * from "./block_voucher.vue?vue&type=script&lang=js&"
import style0 from "./block_voucher.vue?vue&type=style&index=0&id=1d427ec4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports